//NEW: UI_REVAMP
import { useMemo } from 'react';
import { useBettingScreen } from './useStore';

export const useBettingList = (getGame) => {
	const allBetting = useBettingScreen((state) => state.betting);
	const removeBetting = useBettingScreen((state) => state.removeBetting);
	const updateBetPrice = useBettingScreen((state) => state.updateBetPrice);

	const tabBets = useMemo(() => {
		return allBetting;
	}, [allBetting]);

	const gameOrder = useMemo(() => getGame?.data?.map((g) => g.name) || [], [getGame]);

	const categories = useMemo(() => {
		const cats = tabBets.reduce((acc, bet) => {
			if (!acc.find((c) => c.gameType === bet.gameType && c.betType === bet.betType)) {
				acc.push({ gameType: bet.gameType, betType: bet.betType });
			}
			return acc;
		}, []);

		return cats.sort((a, b) => {
			const indexA = gameOrder.indexOf(a.gameType);
			const indexB = gameOrder.indexOf(b.gameType);

			if (indexA !== indexB) {
				if (indexA === -1) return 1;
				if (indexB === -1) return -1;
				return indexA - indexB;
			}

			if (a.betType === 'Straight') return -1;
			if (b.betType === 'Straight') return 1;
			return 0;
		});
	}, [tabBets, gameOrder]);

	return { allBetting: tabBets, removeBetting, categories, updateBetPrice };
};
